<template>
  <div>
    <template v-for="dataByTimeDay in criterionValuesByChild">
      <div v-if="filterChallenges(dataByTimeDay.criterion).length" class="mb-3" :key="dataByTimeDay.time_day">
        <challenge-list-header :time-day-id="dataByTimeDay.time_day" />
        <section>
          <vue-draggable
            :list="challengesSort[dataByTimeDay.time_day]"
            class="challenges-grid list-group"
            handle=".handle"
            @start="dragging = true"
            @end="dragging = false"
            @change="handleSortChallenge(dataByTimeDay.time_day)"
          >
            <template v-for="challenge in filterChallenges(dataByTimeDay.criterion)">
              <challenge-approve-item
                :key="challenge.id"
                :defaultValue="{
                  approved: challenge.parent_approved,
                  qualified: challenge.parent_qualified,
                  qualifiedByChild: challenge.child_approved,
                }"
                :challenge-id="challenge.id"
                :image="challenge.image"
                :text="challenge.text"
                :coin-value="challenge.coin_value"
                :category="challenge.category"
                :frequency-value="challenge.frequencyValue"
                :frequency-id="challenge.frequencyId"
                :criterion-id="challenge.challenge_criterion"
                :checkAll="checkAll"
                @onApprove="
                  (data) =>
                    handleApproveElement({
                      approved: data.approved,
                      id: challenge.challenge_criterion,
                      time_day: dataByTimeDay.time_day,
                    })
                "
                @onDeleteChallenge="
                  $emit('onDeleteChallenge', { challenge, timeDay: dataByTimeDay.time_day })
                "
                @onEditChallenge="
                  $emit('onEditChallenge', { challenge, timeDay: dataByTimeDay.time_day })
                "
              />
            </template>
          </vue-draggable>
        </section>
      </div>
    </template>
    <div class="my-4 d-flex justify-content-center challenge-approve-controls flex-wrap flex-gap">
      <custom-button
        :disabled="!isValidToSend"
        @click="sendData"
        class="w-25 d-flex justify-content-center align-items-center"
      >
        <b-spinner v-if="hasSendingData" small label="Small Spinner" class="mr-3"></b-spinner>
        Save
      </custom-button>
      <custom-button class="w-25" @click="redirectToRewardsChild">
        Next: Claim Rewards
      </custom-button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import VueDraggable from 'vuedraggable';

import { defaultTodayString } from '@/utils/Dates.js';
import CustomButton from '@/components/general/CustomButton.vue';
import ChallengeListHeader from './ChallengeListHeader.vue';
import ChallengeApproveItem from './ChallengeApproveItem.vue';

export default {
  components: { ChallengeListHeader, ChallengeApproveItem, CustomButton, VueDraggable },
  props: {
    currentChild: {
      type: [Number, String],
      default: 0,
    },
    filterSelected: {
      type: Array,
      default: () => [],
    },
    checkAll: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    const TIME_DAY = {
      MORNING: 1,
      AFTERNOON: 2,
      EVENING: 3,
      ANYTIME: 4,
    };
    return {
      hasSendingData: false,
      isValidToSend: false,
      challengesQualifiedByTime: {},
      challengesSort: {
        [TIME_DAY.MORNING]: [],
        [TIME_DAY.AFTERNOON]: [],
        [TIME_DAY.EVENING]: [],
        [TIME_DAY.ANYTIME]: [],
      },
      dragging: false,
    };
  },
  mounted() {
    if (this.criterionValuesByChild && this.criterionValuesByChild.length) {
      const challengesSortWithValues = this.criterionValuesByChild.reduce(
        (acc, cv) => ({ ...acc, [cv.time_day]: this.filterChallenges(cv.criterion) }),
        {},
      );
      this.challengesSort = { ...this.challengesSort, ...challengesSortWithValues };
    }
  },
  computed: {
    ...mapGetters('challenge', ['getCriterionValues']),
    ...mapGetters('user', ['getUserId']),
    ...mapGetters('parent', ['getChildrenData']),
    criterionValuesByChild() {
      return this.getCriterionValues(this.currentChild)[this.currentDate];
    },
    currentDate() {
      return this.$route.query.date ? this.$route.query.date : defaultTodayString();
    },
  },
  methods: {
    ...mapMutations('user', ['setUserType', 'setUserData']),
    handleSortChallenge() {
      this.$emit('onSort', { challengesByTimeDay: this.challengesSort });
    },
    isValidToSave() {
      const timeDays = Object.keys(this.challengesQualifiedByTime) || [];
      return timeDays
        .map((timeDay) => Object.keys(this.challengesQualifiedByTime[timeDay]).length)
        .some((countDataByTimeDay) => Boolean(countDataByTimeDay));
    },
    handleApproveElement({ approved, id, time_day }) {
      if (approved === undefined) {
        delete this.challengesQualifiedByTime[time_day][id];
      } else {
        this.challengesQualifiedByTime[time_day] = {
          ...this.challengesQualifiedByTime[time_day],
          [id]: { value: approved },
        };
      }
      this.isValidToSend = this.isValidToSave();
    },
    filterChallenges(challenges = []) {
      let _challenges = challenges;
      const hasFilters = this.filterSelected.length;
      if (hasFilters) {
        _challenges = challenges.filter((challenge) => {
          const challengeId = challenge['category'] ? challenge['category']['id'] : 0;
          return this.filterSelected.includes(challengeId);
        });
      }

      return _challenges;
    },
    sendData() {
      this.$emit('onSave', { data: this.challengesQualifiedByTime });
    },
    redirectToRewardsChild() {
      const child = this.getChildrenData.find(
        (child) => Number(child.id) === Number(this.currentChild),
      );
      child['originalParentId'] = this.getUserId;
      this.setUserType('child');
      this.setUserData(child);
      this.$router.push({ name: 'Rewards' });
    },
  },
};
</script>
<style lang="scss">
.challenges-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5em;
}
.challenge-approve-controls {
  @media screen and (max-width: 480px) {
    button {
      width: 100% !important;
    }
  }
}
</style>
